import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { Link, useParams } from 'react-router-dom';
// Import the Loader component
import request from '../../Apis/request';
import ReactPaginate from 'react-paginate'; // Import ReactPaginate
import "../Chargers/Charger.css"
import Loader from '../Chargers/Loader';
import "./Meter.css";
import { fetchStatusList } from '../../Apis/StatusListing';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Select from 'react-select';

//meter-record/awaitingstartchargers

const AwaitingStartChargers = () => {
  document.title = "Awaiting Start Charger ";

  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [TransactionData, setTransactionData] = useState([]);
  const [filteredTransactionData, setFilteredTransactionData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); // State for total pages
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStatus, setSelectedStatus] = useState('');
  const [Limit, setLimit] = useState({});
  const [TotalCount, setTotalCount] = useState(0);
  const { mid } = useParams();
  const [MeterStatus, setMeterStatus] = useState('');
  const [chargingList, setChargingList] = useState([]);
  const [selectedchargerType, setselectedchargerType] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [ToDate, setToDate] = useState('');
  const [selectedUserID, setSelectedUserID] = useState('');
  const [ChargerData, setChargerData] = useState([]);
  const [selectedchargerEmi, setSelectedChargerEmi] = useState('');
  const [selectedcharger_id, setselectedcharger_id] =  useState('');
  const [Users, setUsers] = useState([]);
  const [PaymentType, setPaymentType]  =  useState('');

  let navigate = useNavigate();

  const handlefromdate = (e) => {
    setFromDate(e.target.value);
};
const handlePaymentChange = (e) => {
  setPaymentType(e.target.value);
}
const fetchUsers = async () => {
  setLoading(true);
  
  const apiUrl = `${BaseURL}/user`;

  try {
      const response = await axios.get(apiUrl, {
          headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${uniqueToken}`,
          },
      });
      console.log("response", response);
      setUsers(response.data.data || []);
    
  } catch (error) {
      console.error("Error fetching users:", error);
  } finally {
      setLoading(false);
  }
};

const chargerOptions = ChargerData?.map((item) => ({
  value: `${item?.imei_number}@${item?._id}`, // Value combines IMEI and ID
  label: item?.imei_number, // Display the IMEI number
}));

 const handleUserid = (selectedOption) => {
    if (selectedOption) {
      console.log("-----------------------", selectedOption?.wallet_amount)
      const { value: selectedUserID } = selectedOption;
  
      setSelectedUserID(selectedUserID); // Store the user ID
     
    // Store wallet amount
  
    
    } else {
      // Clear selections if no option is selected
      setSelectedUserID(null);
    
  
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchChargers = async () => {
    setLoading(true);
    const apiEndpoint = `${BaseURL}/chargers/?master_charger_type=evtor-0`;

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      setChargerData(response.data.data.data || []);
    } catch (error) {
      console.error("Error fetching ChargerData:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChargers();
  }, []);

  const UserOptons = Users?.map(user => ({
    value: user._id,
    label: `${user.name} (${user.mobile})`,
  mobile: user?.mobile,
  
  }));

const handleReset = (event) => {
  event.preventDefault()
 navigate(`/meter-record/awaitingstartchargers`);
  }

const handleTodate = (e) => {
  setToDate(e.target.value);
}

useEffect(() => {
  const ChargingTypesData = async () => {
    setLoading(true);
    const apiEndpoint = `${BaseURL}/master/ac-0,dc-0`;
    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      setChargingList(response?.data?.data);
    } catch (error) {
      // console.error("Error fetching countries:", error);
    } finally {
      setLoading(false);
    }
  };

  ChargingTypesData();
}, []);

 

  const handleMeterStatus = (e) => {
    setMeterStatus(e.target.value);
  }

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const fetchTransactionData = async (currentPage, from_date, to_date) => {
    setLoadings(true);

    let apiEndpoint = `${BaseURL}/user/transaction?page=${page}&meterStart=meterStart`;
    if (mid) {
      apiEndpoint = `${BaseURL}/user/transaction/${mid}/?page=${page}&meterStart=meterStart`;
    }
    if(searchQuery){
      apiEndpoint +=  `&searchText=${encodeURIComponent(searchQuery.trim())}`;
        }
    if (from_date) {
      apiEndpoint += `&from_date=${from_date} 00:00:00`;
    }
   
    if (to_date) {
      apiEndpoint += `&to_date=${to_date} 23:23:23`;
    };
    if(selectedcharger_id){
      apiEndpoint += `&charger_id=${encodeURIComponent(selectedcharger_id)}`;
    }

    if(selectedUserID) {
      apiEndpoint += `&meter_user_id=${encodeURIComponent(selectedUserID)}`;
    }
    if(selectedchargerType){
      apiEndpoint += `&master_connector_id=${encodeURIComponent(selectedchargerType)}`;
    }
    if (MeterStatus) {
      apiEndpoint +=  `&meter_status=${encodeURIComponent(MeterStatus)}`;
    }
    if(PaymentType) {
      apiEndpoint += `&payment_rf_id=${encodeURIComponent(PaymentType)}`
    };

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      // console.log("response", response);
      setTransactionData(response?.data?.data?.data || []);
      setFilteredTransactionData(response?.data?.data?.data || []); // Initially set filteredChargerData to the full data set
      setPageCount(Math.ceil(response.data?.data?.totalCount / response?.data?.data?.limit)); // Set the total page count from the API response
      setLimit(response?.data?.data?.limit);
      setTotalCount(response?.data?.data?.totalCount);
    } catch (error) {
      console.error("Error fetching ChargerData:", error);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    fetchTransactionData(page, fromDate, ToDate); // Fetch data for the current page
  }, [page]);

  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };

  const DeleteFunction = async (id) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (results) => {
      const DeletechargerApi = `${BaseURL}/chargers/delete`;

      if (results.value) {
        try {
          const res = await axios.put(`${DeletechargerApi}/${id}`, {}, {
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${uniqueToken}`,
            },
          });

          if (res.data.statusCode === 200) {
            Swal.fire({
              icon: "success",
              title: "Deleted!",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            fetchTransactionData(page); // Refresh the data after deletion
          } else {
            Swal.fire({
              icon: "info",
              title: "Notice",
              text: res.data.message || "Unexpected result. Please try again.",
            });
            fetchTransactionData(page); // Refresh the data even if there's an issue
          }

        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "An error occurred while deleting the user.",
          });
        }
      }
    });
  };

  const handleStatusType = async (event, userId) => {
    const status = event.target.value;

    // Update local state
    setUserStatuses(prevStatuses => ({
      ...prevStatuses,
      [userId]: status
    }));

    const url = `${BaseURL}/chargers/changestatus/${userId}`;

    // Create JSON payload
    const statusData = { status };

    try {
      // Send status as JSON instead of FormData
      const response = await axios.put(url, statusData, {
        headers: {
          "Content-Type": "application/json", // Send as JSON
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        console.log("Failed to update status", response.data);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };





  const handleSelectChange = async (meter) => {
    console.log("meterrr", meter) ;
    try {
      Swal.fire({
        title: 'Processing...',
        text: 'Please wait...',
        allowOutsideClick: false,
        showCancelButton: true, // Enables the cancel button
        cancelButtonText: 'Cancel', // Text for the cancel button
        didOpen: () => {
          Swal.showLoading();
        },
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          // Handle cancel action
          Swal.fire('Cancelled', 'The operation was cancelled', 'error');
        }
      });
      //?.meterTransactions?._id, meter?.name, meter?.imei_number, meter?.email
      // Fetch transaction data
      const transactionResponse = await axios.get(`${BaseURL}/user/meter-transaction/${meter?.meterTransactions?._id}`, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
      const transactionData = transactionResponse?.data;
  
      
      
      console.log("transactionData---", transactionData);
      Swal.close();

     

      // Access meterTransactions[0].meterValueLogs (Ensure the array is accessed properly)
      const meterTransactions = transactionData?.data?.[0]?.meterTransactions || [];
      const meterValueLogs = meterTransactions?.length > 0 ? meterTransactions[0]?.meterValueLogs : [];
      const MeterData   =    transactionData?.meterData || [];
      const statementDataa = transactionData?.statementData || [];
      
   
      // Show the pop-up with transaction details

console.log("meterValueLogs", meterValueLogs);
console.log("statementDatasaaaa", statementDataa);

let totalAmount =0;
      Swal.fire({
      
        title: `
   <div style="max-width: 1300px; margin: auto; padding: 20px; background-color: #f9f9f9; font-size: 14px; border-radius: 8px; border: 1px solid #ccc; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
  <!-- Heading -->
  <h4 style="font-size: 20px; text-align: center; font-weight: bold; color: #333; margin-bottom: -900px;">Meter Transaction Logs Details</h4>

  <!-- Table -->
  <table style="width: 100%; border-collapse: collapse; margin-top: -390px;">
    <!-- Style for table -->
    <style>
      th, td {
        padding: 10px;
        text-align: left;
        border: 1px solid #ddd;
      }
      th {
        font-weight: bold;
        color: #555;
        background-color: #f1f1f1;
      }
      td {
        color: #333;
      }
    </style>

    <!-- Rows -->
    <tr>
      <th>IMEI Number</th>
      <td>${MeterData[0]?.imei_number || 'NA'}</td>
      <th>Username</th>
      <td>${MeterData[0]?.name || 'NA'}</td>
      <th>Email</th>
      <td>${MeterData[0]?.email || 'NA'}</td>
    </tr>
    <tr>
      <th>Mobile</th>
      <td>${MeterData[0]?.mobile || 'NA'}</td>
      <th>Connector Name</th>
      <td>${MeterData[0]?.meterTransactions?.connectorName || 'NA'}</td>
      <th>Connector ID</th>
      <td>${MeterData[0]?.meterTransactions?.connector_id || 'NA'}</td>
    </tr>
    <tr>
      <th>Connector Status</th>
      <td>${MeterData[0]?.meterTransactions?.connector_status || 'NA'}</td>
      <th>Before Wallet Amount</th>
      <td>${MeterData[0]?.meterTransactions?.before_wallet_amount || 'NA'}</td>
      <th>After Wallet Amount</th>
      <td>${MeterData[0]?.meterTransactions?.after_wallet_amount || 'NA'}</td>
    </tr>
    <tr>
      <th>Request Amount</th>
      <td>${MeterData[0]?.meterTransactions?.requestAmount || 'NA'}</td>
      <th>Transaction ID</th>
      <td>${MeterData[0]?.meterTransactions?.transactionId || 'NA'}</td>
      <th>Status</th>
      <td>${MeterData[0]?.meterTransactions?.status || 'NA'}</td>
    </tr>
    <tr>
      <th>Wallet Amount</th>
      <td>${MeterData[0]?.meterTransactions?.walletAmount || 'NA'}</td>
      <th>Used Amount</th>
      <td>${MeterData[0]?.meterTransactions?.usedAmount || 'NA'}</td>
      <th>Refund Amount</th>
      <td>${MeterData[0]?.meterTransactions?.refundAmount || 'NA'}</td>
    </tr>
    <tr>
      <th>Meter Start Date</th>
      <td>${MeterData[0]?.meterStartDate || 'NA'}</td>
      <th>Meter End Date</th>
      <td>${MeterData[0]?.meterEndDate || 'NA'}</td>
      <th>Invoice Number</th>
      <td>
        <a href="${MeterData[0]?.meterTransactions?.invoiceURL}" target="_blank" style="color: #333;">${MeterData[0]?.meterTransactions?.invoice_number || 'NA'}</a>
      </td>
      </tr>
      <tr>
       <th>Power Error Counter</th>
      <td>
      ${MeterData[0]?.meterTransactions?.powerErrorCounter || "N/A"}
      </td>
       <th>Current Error Counter</th>
      <td>
        ${MeterData[0]?.meterTransactions?.currentErrorCounter || "N/A"}
      </td>
       <th>Voltage Error Counter</th>
      <td>
       ${MeterData[0]?.meterTransactions?.voltageErrorCounter || "N/A"} 
      </td>
    </tr>
      <tr>
    <th>Vendor Commision</th>
    <td> ${MeterData[0]?.meterTransactions?.vendor_amount || "N/A"}  </td>
    
     <th>Total Used Amount</th>
    <td> </td>
   
    <th>Admin Collection</th>
    <td>${MeterData[0]?.meterTransactions?.admin_collection || "N/A"} </td>
     </tr>
    <tr>
     <th>Comments</th>
    <td>${MeterData[0]?.meterTransactions?.comment || "N/A"} </td>
    </tr>
  </table>
</div>
`,
width: '100%',

        
       
        html: `
<div style="max-width: 100%; overflow-x: auto;">
  <div style="font-weight: bold; margin-bottom: 10px; border: 2px solid #ccc; padding: 10px; border-radius: 5px;">
    <h4>User Wallet Details</h4>
  </div>
  <table style="table-layout: auto; width: 100%; border-collapse: collapse; font-size: 14px; text-align: left;" border="1">
    <thead>
      <tr>
        <th>Sr.No</th>
        <th>Name</th>
        <th>Mobile</th>
       <th>Booking ID</th>
       <th>Amount </th>
       <th>OrderID </th>
       <th>User Type </th>
       <th>Type</th>
       
       <th>Created At </th>


      
      </tr>
    </thead>
    <tbody>
    
      ${statementDataa?.length === 0 ? `
        <tr>
          <td colspan="10" style="text-align: center;">N/A</td>
        </tr>
      ` : statementDataa?.map((log, index) => {
        // Check if any error counter is greater than 0
      
        const amount = log?.amount_number || 0;
        if(log?.payment_status_type === "Dr" ) {
        totalAmount += amount;
        }
        else {
          totalAmount -= amount;
        }
        return `
          <tr>
          
            <td>${index + 1}</td>
            <td>${log?.name}</td>
            <td>${log?.mobile}</td>
            <td>${log?.transactionId}</td>
            <td>${log?.amount}</td>
            <td>${log?.order_id}</td>
            <td>${log?.userType}</td>
          <td>
  ${log?.payment_status_type === "Cr" ? `
    <button class="btn btn-success">Cr</button>
  ` : log?.payment_status_type === "Dr" ? `
    <button class="btn btn-danger">Dr</button>
  ` : `
    <button class="btn btn-secondary">Unknown</button>
  `}
</td>
             <td>${log?.createdAt}</td>
       </tr>
       
          
        `;
      }).join('')}
         <tr>
          <td><b>Admin Collection</b></td>
          <td></td>
          <td> </td>
          <td></td>
          <td>
            <b>${parseFloat(totalAmount.toFixed(2))}</b></td>
          </tr>
    </tbody>
  </table>
</div>

        <div style="max-width: 100%; overflow-x: auto;">
          <div style="font-weight: bold; margin-bottom: 10px; border: 2px solid #ccc; padding: 10px; border-radius: 5px;">
            <h4>Transaction Details</h4>
          </div>
          <table style="table-layout: auto; width: 100%; border-collapse: collapse; font-size: 14px; text-align: left;" border="1">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Meter Start</th>
                <th>End Meter Value</th>
                <th>Consumed Power</th>
                <th>Per Unit Value</th>
                <th>Amount</th>
                <th>Request</th>
                <th>Logs</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              ${meterValueLogs?.length === 0 ? `
                <tr>
                  <td colspan="10" style="text-align: center;">N/A</td>
                </tr>
              ` : meterValueLogs?.map((log, index) => {
                // Check if any error counter is greater than 0
                const hasError = 
                  log?.request[0]?.powerErrorCounter > 0 ||
                  log?.request[0]?.currentErrorCounter > 0 ||
                  log?.request[0]?.voltageErrorCounter > 0;
      
                return `
                  <tr style="background-color: ${hasError ? 'yellow' : 'transparent'};">
                    <td>${index + 1}</td>
                    <td>${log?.meterStart}</td>
                    <td>${log?.endMeterValue}</td>
                    <td>${log?.consumedPower}</td>
                    <td>${log?.perUnitValue}</td>
                    <td>${log?.amount}</td>
                    <td>
                      ${log?.request && log?.request?.length > 0 ? `
                        <span style="color: red;">V|${log?.request[0]?.V || 'N/A'}</span> 
                        <span style="color: blue;">I|${log?.request[0]?.I || 'N/A'}</span> 
                        <span style="color: green;">P|${log?.request[0]?.P || 'N/A'}</span> 
                        <span style="color: purple;">B|${log?.request[0]?.B || 'N/A'}</span>
                      ` : 'No Request Data Available'}
                    </td>
                    <td>
                      <pre>${JSON.stringify(log?.request[0], null, 2) || "N/A"}</pre>
                    </td>
               <td>
  <span
    style={{
      color: log?.request[0]?.S === "true" ? "green" : "red",
    }}
  >
   ${log?.request[0]?.S === true
      ? "ON"
      : log?.request[0]?.S === false
      ? "OFF"
      : "N/A"}
  </span>
</td>
                    <td>
                      ${moment(log?.createdAt).format('DD-MMM-YYYY hh:mm:ss A')}
                    </td>
                  </tr>
                `;
              }).join('')}
            </tbody>
          </table>
        </div>
      `,
      
        showCloseButton: true,
        showConfirmButton: false
      });

    } catch (error) {
      console.error('Error fetching transaction data:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch transaction details.',
      });
    }
  };


  const getStatusColor = (status) => {
    switch (status) {
      case 'Pending':
        return '#f0ad4e'; // Yellow
      case 'Processing':
        return '#ff9800';  // Orange
      case 'Completed':
        return '#28a745'; // Light Green
      case 'Refunded':
        return '#6f42c1';  // Purple
      default:
        return '#6c757d';  // Default (Grey)
    }
  };
  const getStatusColors = (statuss) => {
    switch (statuss) {
      case 'NotAvailable':
      case 'Faulted':
        return '#dc3545'; // Red for "NotAvailable" and "Faulted"
      case 'Available':
        return '#28a745'; // Green for "Available"
      // case 'Preparing':
        return '#28a745';
      case 'Charging':
        return '#ff9800';
      case 'Finishing':
        return '#6f42c1'; // Yellow for "Preparing", "Charging", "Finishing"
      case 'Deleted':
        return '#6c757d'; // Grey for "Deleted"
      case 'Active':
        return '#28a745'; // Blue for "Active"
      case 'InActive':
        return '#17a2b8'; // Light Blue for "InActive"
      default:
        return '6f42c1'; // Default Grey for unhandled statuses
    }
  };
  const handleSearchSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    // Start with an empty array for query params
    let queryParams = [];

    // Add search query filter if available
    if (searchQuery.trim()) {
      queryParams.push(`searchText=${encodeURIComponent(searchQuery.trim())}`);
    }

    // Add status filter if selected
    if (selectedStatus) {
      queryParams.push(`connector_status=${encodeURIComponent(selectedStatus)}`);
    }

    if (MeterStatus) {
      queryParams.push(`meter_status=${encodeURIComponent(MeterStatus)}`);
    }
    if (fromDate) {
      queryParams.push(`from_date=${fromDate} 00:00:00`);
    }
    if (ToDate) {
      queryParams.push(`to_date=${ToDate} 23:23:23`);
    }
    if (selectedchargerType) {
      queryParams.push(`master_station_charger_id=${encodeURIComponent(selectedchargerType)}`);
    };
    if (selectedchargerType) {
      queryParams.push(`master_connector_id=${encodeURIComponent(selectedchargerType)}`);
    }
    
    if(selectedcharger_id) {
      queryParams.push(`charger_id=${encodeURIComponent(selectedcharger_id)}`);
    }
    if(selectedUserID) {
      queryParams.push(`meter_user_id=${encodeURIComponent(selectedUserID)}`);
    }
    if (PaymentType)
      {
        queryParams.push(`&payment_rf_id=${encodeURIComponent(PaymentType)}`);
     }

    // If no filters are selected, fetch all transaction data
    if (queryParams.length === 0) {
      await fetchTransactionData(); // Call the function to fetch all data
      return; // Exit early
    }

    // Join the query parameters with `&`
    const queryString = `${queryParams.join('&')}`;
    setPage(1);
    setLoadings(true); // Start loading spinner

    const url = `${BaseURL}/user/transaction?page=${page}&meterStart=meterStart&${queryString}`;

    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      if (res && res.data?.data?.data) {
        setFilteredTransactionData(res?.data?.data?.data);
        setPageCount(Math.ceil(res?.data?.data?.totalCount / res?.data?.data?.limit));
        setTotalCount(res?.data?.data?.totalCount);  // Set filtered data
      } else {
        setFilteredTransactionData([]); // If no data returned, set to empty array
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoadings(false); // Stop loading spinner
    }
  };

  const handleStop = async (meter) => {
   
    try {
      // Start the loading state with Swal
      Swal.fire({
        title: 'Processing...',
        text: 'Stopping charger, please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      // Make the API request
      const response = await fetch(`${BaseURL}/user/stop-evtor-charging`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${uniqueToken}`,
        },
        body: JSON.stringify({
          "charger_id": meter?.meterTransactions?.charger_id[0],
          "transactionId" : meter?.meterTransactions?.transactionId
        }),
      });
  
      const data = await response.json(); // Parse the JSON response
  
      // Stop the loader
  
  
      // Check if the response indicates success
      if (response?.ok && data?.statusCode === 200) {
        Swal.fire({
          title: 'Success!',
          text: data.message,
          icon: 'success',
          confirmButtonText: 'OK',
        });
        fetchTransactionData();
    
    
      } else {
        Swal.fire({
          title: 'Error!',
          text: data.message || 'An error occurred while stopping the charger.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      // Stop the loader and handle the error
      Swal.close();
      console.error('Error:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Something went wrong. Please try again later.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };
 
  const handlechargerType = (e) => {
    setselectedchargerType(e.target.value);
  }
  const handleChargerEmiChange = (selectedOption) => {
    if (selectedOption) {
      // setPage(1);
      const [imei, id] = selectedOption.value.split("@");
      console.log("Selected IMEI and ID:", imei, id);
      setSelectedChargerEmi(imei);
        setselectedcharger_id(id);
    } else {
      setSelectedChargerEmi(null);
      // setSelectedChargerID(null);
    }
  };




  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
              <div className="d-flex align-items-center">
                <h4 className="mb-0" style={{ marginRight: "10px" }}>Awaiting Start Chargers({TotalCount ? TotalCount : "Loading..."})</h4>  {/* Remove extra margin */}
              
              </div>

              <hr style={{ marginTop: "5px" }} />

              <div className="row">
                <div className="col-sm-12">
                  <form className="form-horizontal" role="form" method="post" style={{ marginTop: "5px" }}>
                    <div className="row px-3">
                      <div className="col-md-4"> {/* Adjusted column size for better spacing */}
                        <div className="form-group d-flex align-items-center">
                          <input
                            type="text"
                           placeholder= "Find Transaction ID"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            className="form-control"
                            style={{
                              height: "38px", // Consistent height with the buttonss
                              borderTopRightRadius: "0",
                              borderBottomRightRadius: "0",
                              width: "200px", // Increased width
                              flexGrow: 1,
                              marginRight: "10px",
                            }}
                          />

<Select
            value={UserOptons.find((option) => option.value === selectedUserID) || null}
            onChange={handleUserid}
            options={UserOptons}
            placeholder="Select User"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                height: '38px',
               // Make width responsive
                boxShadow: 'none',
                minWidth: '150px', // Set minimum width
                maxWidth: '200px',
                marginRight: '10px',
                // minWidth: '200px', // Ensures it can shrink below 150px if needed
                flex: 1, // Allow select to grow and shrink
              }),
            }}
          />
               <Select
  options={chargerOptions} // Pass the options array
  onChange={handleChargerEmiChange} // Handle selection
  placeholder="Select Charger"
  isClearable // Allow clearing the selection
  
  styles={{
    control: (base) => ({
      ...base,
      height: '34px',
      minWidth: '170px', // Set minimum width
      maxWidth: '200px',
      marginRight: '10px',
    }),
  }}
/>
                         
                          <select
                            type="text"
                            placeholder="Find Data Here"

                            onChange={handleMeterStatus}
                            className="form-control"
                            style={{
                              height: "38px", // Consistent height with the buttonss
                              borderTopRightRadius: "0",
                              borderBottomRightRadius: "0",
                              width: "150px", // Increased width
                              flexGrow: 1,
                              marginRight: "10px",
                            }}
                          >

                            <option value="">Meter Status</option>
                            <option value="Completed">Completed</option>
                            <option value="Processing">Processing</option>


                          </select>

                          <select
                            type="text"

                            onChange={handlechargerType}

                            className="form-control"
                            style={{
                              height: "38px", borderTopRightRadius: "0",
                              borderBottomRightRadius: "0",
                              width: "250px", // Increased width
                              flexGrow: 1,
                              marginRight: "10px",
                            }} // Set the same height as the button
                          >
                            <option value ="">Charger Type</option>
                            {chargingList?.map((item) => {
                              return (
                                <option
                                  key={item?._id}
                                  value={item?._id}
                                >
                                  {item?.title}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            type="text"

                            onChange={handlePaymentChange}

                            className="form-control"
                            style={{
                              height: "38px", borderTopRightRadius: "0",
                              borderBottomRightRadius: "0",
                              width: "250px", // Increased width
                              flexGrow: 1,
                              marginRight: "10px",
                            }} // Set the same height as the button
                          >
                            <option>Select Payment Option</option>
                         <option value="payment_id">QR Code</option>
                         <option value="rf_id">RFID</option>
                          </select>
                          <input
  type="text"
  className="form-control select2 select2-offscreen"
  onFocus={(e) => (e.target.type = "date")}
  onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
  placeholder="From Date"
  onChange={handlefromdate}
  style={{ height: '34px', marginRight: '10px', width: '120px' }} // Adjusted width for dates
/>
<input
  type="text"
  className="form-control select2 select2-offscreen"
  onFocus={(e) => (e.target.type = "date")}
  onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
  placeholder="To Date"
  onChange={handleTodate}
  style={{ height: '34px', marginRight: '10px', width: '120px' }} // Adjusted width for dates
/>
                      
                          <button
                            type="submit"
                            onClick={handleSearchSubmit}
                            className="btn btn-primary"
                            style={{
                              height: "38px",
                              lineHeight: "20px",
                              marginRight: "10px",
                            }}
                          >
                            Search
                          </button>
                          <button
                            type="submit"
                            onClick={handleReset}
                            className="btn btn-primary"
                            style={{
                              height: "38px",
                              lineHeight: "20px",
                              marginRight: "10px",
                            }}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>


              <div className="card-body" style={{ marginLeft: "-19px" }}>
                {loadings ? (
                  <Loader /> // Use the Loader component
                ) : (
                  <>
                    <div className="table-responsive">
                      <table
                        className="display dataTable"
                        style={{
                          tableLayout: 'auto',
                          width: '100%',
                          borderCollapse: 'collapse',
                        }}
                        id="advance-1"
                      >
                        <thead>
                          <tr>
                            <th style ={{ "position": "sticky",
          "left": 0,
          "zIndex": 1,}}> Sr. No</th>
                            <th>Transaction ID</th>
                            <th>IMEI Number</th>
                          <th>Meter Start Date</th>
                          <th>Meter Stop Date</th>
                            <th>Mobile</th>
                            <th>Name</th>
                            <th>Meter Start</th>
                            <th>Meter Stop</th>
                            <th>Meter Diff</th>
                            <th>Before Wallet Amount</th>
                            <th>After Wallet Amount</th>
                            <th>Request Amount</th>
                            <th>Used Amount</th>
                            <th>Refund Amount</th>
                            <th>Invoice Number</th>
                          
                    
                            <th>Meter Status</th>
                            <th>Connector Status</th>
                         <th>Action</th>
                            <th>Comments</th>
                            {/* <th>Actions</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {filteredTransactionData?.length === 0 ? (
                            <tr>
                              <td colSpan="18" className="text-center"> No Data</td>
                            </tr>
                          ) : (
                            filteredTransactionData?.map((meter, index) => {
                              const status = meter?.meterTransactions?.status || 'N/A'; // Default to 'N/A' if status is missing

                              return (
                                <tr key={index}>
                                  <td style={{     whiteSpace: "nowrap", position: "sticky",left: 0, zIndex: 1 }}>{(page - 1) * Limit + index + 1}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>
                                    <Link to=""
                                      title="Meter Transaction Logs"
                                      className="transaction-links"   // Specify the route if needed, or leave empty if not using routing
                                      onClick={(e) => {
                                        e.preventDefault();  // Prevents the default link behavior
                                        handleSelectChange(meter);
                                      }}
                                    >
                                      {meter?.meterTransactions?.transactionId}
                                    </Link>

                                  </td>

                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.imei_number}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.meterStartDate}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.meterEndDate}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.mobile}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.name}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.meterTransactions?.meterStart}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.meterTransactions?.meterStop}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.meterTransactions?.meterDiff}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.meterTransactions?.before_wallet_amount}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.meterTransactions?.after_wallet_amount}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.meterTransactions?.requestAmount}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.meterTransactions?.usedAmount}</td>
                                  <td style={{ whiteSpace: 'nowrap' }}>{meter?.meterTransactions?.refundAmount}</td>
                                  <td>
                                  <a href={meter?.meterTransactions?.invoiceURL} target="_blank" rel="noopener noreferrer">
    {meter?.meterTransactions?.invoice_number}
  </a></td>
                            
                                  <td style={{ whiteSpace: 'nowrap' }}>
                                    <button
                                      className="btn"
                                      style={{
                                        backgroundColor: getStatusColor(status),  // Background color based on status
                                        color: 'Black',                           // Ensure the text is readable on all backgrounds
                                        border: 'none',                           // Optional: removes border for a cleaner look
                                        width: '100px',                           // Fixed width
                                        height: '40px',                           // Fixed height
                                        padding: '0',                             // Ensure no extra padding affects size
                                        lineHeight: '40px',                       // Center text vertically
                                        textAlign: 'center'                       // Center text horizontally
                                      }}
                                    >
                                      {status}
                                    </button>

                                  </td>
                               
                                  <td style={{ whiteSpace: 'nowrap' }}>


                                    <button
                                      className="btn"
                                      style={{
                                        backgroundColor: getStatusColors(meter?.meterTransactions?.connector_status),  // Background color based on status
                                        color: 'Black',                           // Ensure the text is readable on all backgrounds
                                        border: 'none',                           // Optional: removes border for a cleaner look
                                        width: '100px',                           // Fixed width
                                        height: '40px',                           // Fixed height
                                        padding: '0',                             // Ensure no extra padding affects size
                                        lineHeight: '40px',                       // Center text vertically
                                        textAlign: 'center'                       // Center text horizontally
                                      }}
                                    >
                                      {meter?.meterTransactions?.connector_status}
                                    </button>
                                  </td>
                                  <td>
  {status !== "Completed" && (
   <button className="btn btn-danger" onClick={() => handleStop(meter)}>Stop</button>
  )}
</td>
                                 
                                 
                                 
                                 
                                 
                                 
                                 
                               
                                  
           

                            


                                  <td style={{
                                    whiteSpace: 'nowrap',
                                    backgroundColor: '#f8f9fa', // Light gray background
                                    borderRadius: '5px', // Rounded corners
                                    padding: '10px', // Increased padding for better spacing
                                    fontWeight: '500', // Medium weight for better readability
                                    color: '#333', // Darker text color for contrast
                                    position: 'relative', // Required for tooltip positioning
                                  }}>
                                    <div className="comment-container" style={{ position: 'relative' }}>
                                      {meter?.meterTransactions?.comment?.length > 30 ? (
                                        <>
                                          <span>{meter?.meterTransactions?.comment.slice(0, 30)}...</span>
                                          <div className="tooltip" style={{
                                            visibility: 'hidden',
                                            width: '200px',
                                            backgroundColor: 'black',
                                            color: '#fff',
                                            textAlign: 'center',
                                            borderRadius: '6px',
                                            padding: '5px',
                                            position: 'absolute',
                                            zIndex: '1',
                                            bottom: '100%', // Position above the text
                                            left: '50%',
                                            marginLeft: '-100px',
                                            opacity: '0',
                                            transition: 'opacity 0.3s',
                                          }}>
                                            {meter?.meterTransactions?.comment}
                                          </div>
                                        </>
                                      ) : (
                                        <span>{meter?.meterTransactions?.comment}</span>
                                      )}
                                    </div>
                                  </td>

                                  {/* <td style={{ whiteSpace: 'nowrap' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Link to={`/meter-record/meter-list/view/${meter?.meterTransactions?._id}`} state={{ MeterViewData: meter }}>
                <i className="fa fa-eye"></i>
              </Link>
            </td> */}
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>

                    </div>

                    <div className="pagination-container mt-4">
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        forcePage={page - 1}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AwaitingStartChargers;
